import { Field, ObjectType, ID, Float, InputType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ProductOperationCostInput')
export class ProductOperationCost {
  @Field(() => ID)
  @Prop({ type: String, default: () => generateEntityId('poc') })
  _id: string

  @Field(() => Float)
  @Prop({ type: Number })
  laborCost: number

  @Field(() => Float)
  @Prop({ type: Number })
  estimatedDuration: number

  @Field(() => Float)
  @Prop({ type: Number })
  perUnitCost: number
}
